<script>
  import { getContext } from "svelte";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  const { xGet, yScale } = getContext("LayerCake");

  const { data, fill = urbanColors.blue } = $props();
  function yGet(d) {
    return $yScale(d.value);
  }
</script>

{#if !isNaN(yGet(data))}
  <circle
    cx={$xGet(data)}
    cy={yGet(data)}
    r="4"
    {fill}
    stroke={urbanColors.white}
    stroke-width={2}
  />
{/if}

<style>
</style>
